import Description from "./description.js.jsx";
import Gallery from "../../../../components/filter_desktop/camp_card/gallery.js";

export default class WaterCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let descriptionProps = {
      data: this.props.data,
      name: this.props.name,
      characteristic: this.props.characteristic,
      count_variants: this.props.count_variants,
      seo_path: this.props.seo_path,
      short_description: this.props.short_description,
      water_url: this.props.water_url,
      active_status: this.props.active_status,
      active_post_page_status: this.props.active_post_page_status
    };

    return (
      <div className="card card__sight card_big" id={this.props.data.id}>
        <div className='card__thumb'>
          {this.props.pictures.length === 0 &&
            <Gallery pics={this.props.default_photo}
                     filter_alt_img="Водоем"
                     for_waters={true}
                     no_pics={true} />}

          {this.props.pictures.length > 0 &&
            <Gallery pics={this.props.pictures}
                     filter_alt_img={this.props.filter_alt_img}
                     for_waters={true}
                     no_pics={false} />}
        </div>

        <div className="card__desc">
          <Description {...descriptionProps} />
        </div>
      </div>
    )
  }
}
